import consumer from "./consumer"

document.addEventListener("DOMContentLoaded", function () {

  const chatForm = document.getElementById("js-chat-form");
  const chatBox = document.querySelector('#js-chat-box');

  if (chatForm) {
    const messageInput = chatForm.querySelector('textarea[name="message[body]"]');
    if (messageInput) {
      messageInput.addEventListener("keydown", function (event) {
        if (event.isComposing || event.key !== "Enter" || event.shiftKey) {
          return;
        }

        const submitBtn = chatForm.querySelector("#js-chat-send");
        if ((submitBtn && submitBtn.disabled) || chatForm.dataset.submitting === "true") {
          event.preventDefault();
          return;
        }

        if (messageInput.value.trim() === "") {
          return;
        }

        event.preventDefault();
        if (chatForm.requestSubmit) {
          chatForm.requestSubmit();
        } else {
          if (submitBtn) {
            submitBtn.click();
          } else {
            chatForm.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
          }
        }
      });
    }

    chatForm.addEventListener("submit", function (event) {
      const submitBtn = chatForm.querySelector("#js-chat-send");
      if (chatForm.dataset.submitting === "true" || (submitBtn && submitBtn.disabled)) {
        event.stopImmediatePropagation();
        event.preventDefault();
        return;
      }

      chatForm.dataset.submitting = "true";
      event.preventDefault();
      const submitIcon = submitBtn ? submitBtn.querySelector("i") : null;

      if (submitBtn) {
        submitBtn.disabled = true;
        if (submitIcon) {
          submitIcon.classList.remove("fa-paper-plane");
          submitIcon.classList.add("fa-spinner", "fa-spin");
        }
      }

      const formData = new FormData(chatForm);

      fetch(chatForm.action, {
        method: "POST",
        body: formData,
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Accept": "application/json"
        },
        credentials: "same-origin"
      })
        .then(response => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error("Failed to send message");
          }
        })
        .then(data => {
          chatForm.reset();
          delete chatForm.dataset.submitting;
          if (submitBtn) {
            submitBtn.disabled = false;
            if (submitIcon) {
              submitIcon.classList.remove("fa-spinner", "fa-spin");
              submitIcon.classList.add("fa-paper-plane");
            }
          }
          if (data.html && chatBox) {
            // Check if message is already in DOM (ActionCable might be faster)
            if (data.message_id && document.getElementById(`js-chat-item-${data.message_id}`)) {
              console.log("Message already in DOM from ActionCable:", data.message_id);
            } else {
              chatBox.insertAdjacentHTML("afterbegin", data.html);
            }
          }

          if (data.conversation_id) {
            const cable = consumer || (window.App && window.App.cable);
            if (cable) {
              if (chatBox) chatBox.dataset.conversationId = data.conversation_id;
              
              // Only subscribe if not already subscribed
              const identifier = JSON.stringify({channel: "ChatChannel", conversation_id: data.conversation_id});
              if (cable.subscriptions.findAll(identifier).length === 0) {
                console.log("Subscribing to NEW conversation:", data.conversation_id);
                cable.subscriptions.create(
                  { channel: "ChatChannel", conversation_id: data.conversation_id },
                  {
                    received(data) {
                      if (data.html_me && data.html_other) {
                        if (data.message_id && document.getElementById(`js-chat-item-${data.message_id}`)) {
                          return;
                        }
                        const you = String(data.sender_id) === String(window.CURRENT_USER_ID);
                        chatBox.insertAdjacentHTML("afterbegin", you ? data.html_me : data.html_other);
                      }
                    }
                  }
                );
              }
            }
          }
        })
        .catch(error => {
          delete chatForm.dataset.submitting;
          if (submitBtn) {
            submitBtn.disabled = false;
            if (submitIcon) {
              submitIcon.classList.remove("fa-spinner", "fa-spin");
              submitIcon.classList.add("fa-paper-plane");
            }
          }
          console.error("Error sending message:", error);
          alert(chatForm.dataset.errorString || "Error sending message");
        });
    });
  }

  if (chatBox) {
    const CURRENT_CONVERSATION_ID = chatBox.dataset.conversationId;
    console.log("chat loaded. ConversationID:", CURRENT_CONVERSATION_ID)
    
    const cable = consumer || (window.App && window.App.cable);
    if (!cable) {
      console.warn("ChatChannel: missing ActionCable consumer; subscription skipped.");
    } else if (CURRENT_CONVERSATION_ID) {
      const identifier = JSON.stringify({channel: "ChatChannel", conversation_id: CURRENT_CONVERSATION_ID});
      if (cable.subscriptions.findAll(identifier).length === 0) {
        cable.subscriptions.create({channel: "ChatChannel", conversation_id: CURRENT_CONVERSATION_ID},
        {
          received(data) {
            if (data.html_me && data.html_other) {
              if (data.message_id && document.getElementById(`js-chat-item-${data.message_id}`)) {
                return;
              }
              const you = String(data.sender_id) === String(window.CURRENT_USER_ID);
              chatBox.insertAdjacentHTML("afterbegin", you ? data.html_me : data.html_other);
            }
          }
        }
      );
      }
    }
  }
});
